import { FC } from 'react';
import { useSectionDetails } from '../../services/graph/hooks/category';
import { withBestEffort } from '../error/BestEffort';
import { PictureLink } from './PictureLink';

interface SectionLinkProps {
  driveItemId: string;
}

const SectionLinkContent: FC<SectionLinkProps> = ({ driveItemId }) => {
  const { sectionData, imageUrl } = useSectionDetails(driveItemId);
  if (!sectionData) throw new Error('Could not get section data');
  if (!sectionData.name) {
    throw new Error("Section must have a name");
  }

  return (
    <PictureLink
      url={imageUrl}
      title={sectionData.name}
      to={`sections/${driveItemId}`}
      description={sectionData.description}
    />
  );
};

export const SectionLink = withBestEffort(SectionLinkContent);
